{
  "name": "pds-tm",
  "version": "1.1.5",
  "private": true,
  "scripts": {
    "start": "node scripts/start.js",
    "build:prod": "node scripts/build.js prod",
    "build:stage": "node scripts/build.js stage",
    "build:tm2": "node scripts/build.js tm2",
    "lint": "standard | snazzy",
    "deploy:prod": "./scripts/deploy.sh prod",
    "deploy:stage": "./scripts/deploy.sh stage",
    "deploy:tm2": "./scripts/deploy.sh tm2",
    "rollback:prod": "./scripts/rollback.sh prod",
    "rollback:stage": "./scripts/rollback.sh stage",
    "test": "standard && npm run lint:md && node test/office.js && node test/save.js",
    "hallmark": "npm run fix:md",
    "lint:md": "remark --frail --quiet --no-stdout \"*.md\"",
    "fix:md": "remark --frail --quiet \"*.md\" --output"
  },
  "peerDependencies": {
    "react-modal": "^3.14.4"
  },
  "dependencies": {
    "@azure/msal-browser": "2.32.2",
    "@emotion/react": "^11.14.0",
    "@emotion/styled": "^11.14.0",
    "@mui/icons-material": "^7.0.1",
    "@mui/material": "^7.0.1",
    "@pergas-common/pergas-components": "0.9.1",
    "@pergas-common/pergas-icons": "1.7.1",
    "@pergas-pds/pds-api-client": "^18.0.1",
    "@pergas-pds/pds-permissions": "^3.3.0",
    "@reduxjs/toolkit": "^1.8.2",
    "async": "^3.2.0",
    "base64-js": "^1.5.1",
    "buffer": "^6.0.3",
    "clone-deep": "^4.0.1",
    "dayjs": "^1.9.7",
    "jszip": "^3.10.1",
    "react": "^18.2.0",
    "react-dom": "^18.2.0",
    "react-is": "^18.2.0",
    "react-redux": "^7.2.1",
    "socket.io-client": "^4.0.0",
    "styled-components": "^5.3.5",
    "url-parse": "^1.5.3",
    "xml-js": "^1.6.11"
  },
  "devDependencies": {
    "esbuild": "^0.28.2",
    "remark-cli": "^12.0.1",
    "remark-gfm": "^4.0.1",
    "remark-lint-no-shortcut-reference-link": "^4.0.1",
    "remark-preset-lint-consistent": "^6.0.1",
    "remark-preset-lint-recommended": "^7.0.1",
    "remark-validate-links": "^13.1.0",
    "snazzy": "^9.0.0",
    "standard": "^17.0.0"
  },
  "remarkConfig": {
    "plugins": [
      "remark-gfm",
      "remark-preset-lint-consistent",
      "remark-preset-lint-recommended",
      ["remark-lint-no-shortcut-reference-link", false],
      "remark-validate-links"
    ],
    "settings": {
      "fences": true,
      "listItemIndent": "one",
      "bullet": "-",
      "rule": "-",
      "emphasis": "_",
      "strong": "*"
    }
  },
  "standard": {
    "globals": [
      "atob",
      "fetch",
      "localStorage",
      "sessionStorage",
      "Office",
      "Word",
      "Excel"
    ]
  }
}
